import type { DirectiveBinding } from 'vue';

interface ClickOutsideElement extends HTMLElement {
  __clickOutsideHandler?: (event: Event) => void;
  __clickOutsideListening?: boolean;
  __clickOutsideCallback?: ((event: Event) => void) | null;
}

const isEventInsideElement = (event: Event, element: HTMLElement) => {

  const anyEvent = event as Event & { composedPath?: () => EventTarget[] };
  const path = typeof anyEvent.composedPath === 'function' ? anyEvent.composedPath() : null;

  if (path && path.length > 0) {

    return path.includes(element);

  }

  const target = event.target as Node | null;

  return !!target && element.contains(target);

};

export const clickOutside = {
  mounted(el: ClickOutsideElement, binding: DirectiveBinding) {

    el.__clickOutsideCallback = typeof binding.value === 'function' ? binding.value : null;

    const handler = (event: Event) => {

      if (!isEventInsideElement(event, el)) {

        el.__clickOutsideCallback?.(event);

      }

    };

    el.__clickOutsideHandler = handler;

    if (import.meta.client) {

      el.__clickOutsideListening = true;
      document.addEventListener('mousedown', handler, true);
      document.addEventListener('touchstart', handler, true);

    }

  },

  updated(el: ClickOutsideElement, binding: DirectiveBinding) {

    el.__clickOutsideCallback = typeof binding.value === 'function' ? binding.value : null;

  },

  beforeUnmount(el: ClickOutsideElement) {

    if (el.__clickOutsideHandler && import.meta.client) {

      if (el.__clickOutsideListening) {

        document.removeEventListener('mousedown', el.__clickOutsideHandler, true);
        document.removeEventListener('touchstart', el.__clickOutsideHandler, true);

      }

      delete el.__clickOutsideHandler;
      delete el.__clickOutsideListening;
      delete el.__clickOutsideCallback;

    }

  },

  // For SSR compatibility
  getSSRProps() {

    return {};

  },
};

export default clickOutside;
